export function uuid(): string {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID()
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0
    const v = c === "x" ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

const VISITOR_KEY = "relia.visitor_id"

export function getVisitorId(storage: Storage = window.localStorage): string {
  let id = storage.getItem(VISITOR_KEY)
  if (!id) {
    id = uuid()
    storage.setItem(VISITOR_KEY, id)
  }
  return id
}

export function detectDevice(userAgent: string): string {
  const s = userAgent.toLowerCase()
  if (/(ipad|tablet|playbook|silk)|(android(?!.*mobile))/i.test(s)) return "tablet"
  if (/mobi|iphone|ipod|android/i.test(s)) return "mobile"
  return "desktop"
}

export function randomHex(bytes: number): string {
  if (typeof crypto !== "undefined" && typeof crypto.getRandomValues === "function") {
    const arr = new Uint8Array(bytes)
    crypto.getRandomValues(arr)
    return Array.from(arr, (b) => b.toString(16).padStart(2, "0")).join("")
  }
  let s = ""
  for (let i = 0; i < bytes * 2; i++) {
    s += Math.floor(Math.random() * 16).toString(16)
  }
  return s
}

export function generateTraceparent(): { header: string; traceId: string; spanId: string } {
  const traceId = randomHex(16)
  const spanId = randomHex(8)
  return {
    header: `00-${traceId}-${spanId}-01`,
    traceId,
    spanId,
  }
}
